import { Component, OnInit } from '@angular/core';
import { ViewlinksService } from '../../modules/dashboard/view-links/view-links.service';
import { CommonService } from '../../core/services/common/common.service';
import { OpenlinksService } from '../openLink/openlink.service';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { NavigationService } from '../../core/services/navigation/navigation.service';
import { environment } from 'src/environments/environment';
import { constants } from '../../../../src/appconstant'

@Component({
  selector: 'app-openlink',
  templateUrl: './openlink.component.html',
  styleUrls: ['./openlink.component.scss']
})
export class OpenlinkComponent implements OnInit {
  imagepath: any;
  AllLinks: any = [];
  count: number;
  interval: any = [];
  ViewLinkObj: any = [];
  viewList = true;
  linkbyIndex: any = [];
  oneLock = false;
  multiLock = true;
  Links: any = {};
  tokenfromurl: any;
  entity_name: any;
  isImage: boolean = false;
  logo: any
  currentUser: any;
  userAllowed: boolean = false;
  linkdata: any;
  showError:boolean=false;
  
  constructor(
    private route: ActivatedRoute,
    private OpenlinksService: OpenlinksService,
    private LinkService: ViewlinksService,
    private CommonService: CommonService,
    private router: Router,
    private spinner: NgxSpinnerService,
    private navigate: NavigationService,
  ) {

  }


  ngOnInit() {
    this.spinner.show()
    let url = this.router.url;
    let token = url.replace("/en/open-lock/", "");
    this.tokenfromurl = token;
    console.log(token)
    localStorage.getItem("token") ? this.user(token) : this.getLinksByToken(token)  ;

    this.getTupasStatus();

  }

  getTupasStatus() {
    this.route.queryParams
      .subscribe(params => {
        if (params.error) {
          this.userAllowed = false;
          this.showError = true;
          this.CommonService.getTranslationResponse('errorToastr', 'TUPAS_NOT_VERIFIED');
        }
      })
  }

  getLinksByToken(token) {
    console.log(token)
    this.OpenlinksService.getLinkByToken(token).subscribe((d) => {

      if (d.link) {
        this.linkdata = d;
        if (d && d.link && d.link.tupas_required && this.currentUser && this.currentUser.properties.tupas != "verified") {
          this.tupasLogin();
        }
        if (this.currentUser && (this.currentUser.user_properties.role == 1 || this.currentUser.user_properties.role == 4)) {
          this.userAllowed = true;          
        }
        else if(d.link){
          this.userAllowed = true
          for (const linkFor of d.link.link_for_user_data) {
            if(this.currentUser == null) {
              this.navigate.navigateTo("login")
            }
            if (linkFor.for_user_email && linkFor.for_user_email === this.currentUser.email) {
              this.userAllowed = true;
            }
            else{
              this.CommonService.getTranslationResponse('errorToastr', 'you are not allowed to access this link');
            }
          }
        }

        /* if(this.userAllowed){
          this.getStatusforNavigate(this.linkdata)
        } */
        console.log("SUCCESS", d);
        this.getLinksObj(this.linkdata);
      } else if (d.error) {
        this.userAllowed=false;
        this.showError = true;
        this.CommonService.getTranslationResponse('errorToastr', d.error);
        console.log("ERROR");
      }
    });
  }

  getLinksObj(linkData) {
    for (let j = 0; j < linkData.link.links.doorLock.length; j++) {
      let tempLink = {
        url: this.tokenfromurl + "/" + linkData.link.links.doorLock[j],
        lock_id: linkData.link.links.doorLock[j],
        lockStatus: true,
        iswait: false,
        counter: 0
      }
      this.AllLinks.push(tempLink);
    }
    for (let i = 0; i < linkData.link.links.subLockers.length; i++) {
      let tempLink = {
        url: this.tokenfromurl + "/" + linkData.link.links.subLockers[i].Model_id,
        lock_id: linkData.link.links.subLockers[i].sublocker_id,
        lockStatus: true,
        iswait: false,
        counter: 0
      }
      this.AllLinks.push(tempLink);
    }
    console.log(this.AllLinks)
  }

  setCounter(index) {
    this.AllLinks[index].counter = 10;


    this.interval[index] = setInterval(() => {
      this.AllLinks[index].lockStatus = false;
      console.log(this.AllLinks[index].counter);
      this.AllLinks[index].counter--;


      if (this.AllLinks[index].counter < 0) {
        this.AllLinks[index].lockStatus = true;
        clearInterval(this.interval[index]);
      };
    }, 1000);
  }

  openLock(linkUrl) {
    this.AllLinks[linkUrl].iswait = true;

    console.log("==>", this.AllLinks[linkUrl])

    let basename = this.AllLinks[linkUrl].url.split("/")[2];
    let urlinitial = this.AllLinks[linkUrl].url.replace("https://" + basename + "/en/", "")
    let url = "request-lock/" + urlinitial;

    console.log(url);

    this.LinkService.openLock(url).subscribe((d) => {
      if (d['data']) {
        this.AllLinks[linkUrl].iswait = false;
        console.log("SUCCESS");
        this.setCounter(linkUrl);
        this.AllLinks[linkUrl].lockStatus = false;
      } else if (d.error) {
        this.AllLinks[linkUrl].iswait = false;
        console.log("ERROR", d.error);
        this.CommonService.getTranslationResponse('errorToastr', d.error);
        
      }
    });
  }

  user(token) {
    this.spinner.show()
    this.OpenlinksService.getuser().subscribe((d) => {
      console.log("user data on fail ", d);
      if (d) {
        this.currentUser = d;
        this.getLinksByToken(token);
        this.spinner.hide()
        this.entity_name = d.first_name
        if (d.user_properties.logoUrl && d.user_properties.logoUrl != " ") {
          this.isImage = true;
          this.logo = constants.AWS_URL + d.user_properties.logoUrl;
        }

        console.log("USER", d)
        console.log("USERNAME ", this.entity_name)
        console.log("SUCCESS");
      } else if (d.error) {
        this.navigate.navigateTo("login")

        this.CommonService.getTranslationResponse('errorToastr', 'ENABLE TO LOAD LINKS');

        this.spinner.hide()
        console.log("ERROR");
      } else {
        this.navigate.navigateTo("login")
        this.spinner.hide();
        this.CommonService.getTranslationResponse('errorToastr', 'ENABLE TO LOAD LINKS');

      }
    });
  }

 

  tupasLogin() {
    let payload = this.retrievePayload();
    this.OpenlinksService.tupas(payload).subscribe((d) => {

      console.log(d)
      if (d) {
        let data = d['data']['object'];
        console.log("SUCCESS", data);
        window.open(data, "_self")
      } else if (d.error) {
        console.log("ERROR");
      }
    });
  }
  retrievePayload() {
    return {
      "url": environment.WEB_URL + `en/dashboard/view-links`,
      "action": "connect",
      "account_from": 'liiteri',
    }
  }
}

